import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_INTEGRATIONS_FEATURE_GROUP } from './group';

export const PAYMENTS_INTEGRATIONS_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0400',
    name: 'payments_integrations:read',
    description: 'View the integration catalogue and which are connected',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_INTEGRATIONS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0401',
    name: 'payments_integrations:update',
    description: 'Connect, test and disconnect an integration',
    action: 'update',
    product: 'payments',
    parentGuid: PAYMENTS_INTEGRATIONS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_INTEGRATIONS_FEATURE_GROUP } from './group';

export const PAYMENTS_INTEGRATIONS_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_INTEGRATIONS_FEATURE_GROUP],
  features: featureList(PAYMENTS_INTEGRATIONS_FEATURES),
};
